import { useRef, useState } from "react";
import { toast } from "react-toastify";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { hideFormLoader, showFormLoader } from "../../actions";
import apiservice from "../../common/services/apiService";
import { Col, Image } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";

const BannerHireNowForm = ({
	schema,
	initialValues,
	isNew
}) => {
	const router = useRouter();
	const dispatch = useDispatch();
    const [captchaError, setCaptchaError] = useState('')

	const sitekey = process.env.NEXT_PUBLIC_RECAPTCHA_V3;
	const reCaptchaRef = useRef(null);

	const validateCaptchaV3 = () => {
		return new Promise(async (resolve, reject) => {
			reCaptchaRef.current.executeAsync().then(async (value) => {
				resolve(value)
				// const captchaRes = await axios.post(`/api/validateCaptchaV3`, {
				// 	token: value,
				// });
				// if (captchaRes.status === 200 && captchaRes.data.success) {
				// 	setCaptchaError('')
				// 	resolve(true)
				// } else {
				// 	setCaptchaError('Invalid captcha.')
				// 	reject(false);
				// }
			});
		});
	};

	const formRef = useRef(null);

	const handleRest = () => {
		formRef.current?.resetForm();
	};

	const onSubmit = async (formData, e) => {
		dispatch(showFormLoader());
		const isHuman = await validateCaptchaV3();
		let data = { ...formData };

		if (isHuman) {
			const form_data = new FormData();
			for (let key in data) {
				form_data.append(key, data[key]);
			}
			form_data.append("captcha_token_v3", isHuman);
			form_data.append("page_link", window.location.href);
			form_data.append("page_title", document.title);
			if (!!sessionStorage.getItem("hdd-referer")) {
				form_data.append(
					"page_referer",
					sessionStorage.getItem("hdd-referer")
				);
			}
			const lst = await apiservice.multipart_post("hire-now", form_data);
			if (lst.data.success) {
				sessionStorage.setItem("form-data", JSON.stringify(data));
				sessionStorage.removeItem("hdd-referer");
				router.push("/thank-you");
				dispatch(hideFormLoader());
				e.resetForm();
				handleRest();
			} else {
				toast.error(lst.data.message);
			}
		} else {
			handleRest();
			dispatch(hideFormLoader());
		}
	};

	return (
		<Formik
			initialValues={initialValues}
			innerRef={formRef}
			validationSchema={schema}
			onSubmit={onSubmit}
		>
			{({}) => (
				<Form>
					<div className="schedule-interview-right">
						<div className="schedule-form">
							<div className="row">
								<div className="col-lg-6 col-md-6">
									<div className="form-group form-floating normal">
										<Field
										id="employee_name"
											className="form-control"
											name="employee_name"
											placeholder="Name*"
										/>
										<label
											htmlFor="employee_name"
											className="form-label"
										>
											Name*
										</label>
										<ErrorMessage
											className="error-message"
											name="employee_name"
											component="span"
											style={{
												color: "red",
											}}
										/>
									</div>
								</div>
								<div className="col-lg-6 col-md-6">
									<div className="form-group form-floating normal">
										<Field
										id="employee_email"
											className="form-control"
											name="employee_email"
											placeholder="Work Email*"
										/>
										<label
											htmlFor="employee_email"
											className="form-label"
										>
											Work Email*
										</label>
										<ErrorMessage
											className="error-message"
											name="employee_email"
											component="span"
											style={{
												color: "red",
											}}
										/>
									</div>
								</div>
								<div className="col-lg-6 col-md-6">
									<div className="form-group form-floating normal">
										<Field
										id="contact_no"
											className="form-control"
											name="contact_no"
											placeholder="Mobile Number"
										/>
										<label
											htmlFor="contact_no"
											className="form-label"
										>
											Mobile Number
										</label>
										<ErrorMessage
											className="error-message"
											name="contact_no"
											component="span"
											style={{
												color: "red",
											}}
										/>
									</div>
								</div>
								<div className="col-lg-6 col-md-6">
									<div className="form-group form-floating normal">
										<Field
										id="company_name"
											className="form-control"
											name="company_name"
											placeholder="Company"
										/>
										<label
											htmlFor="company_name"
											className="form-label"
										>
											Company
										</label>
										<ErrorMessage
											className="error-message"
											name="company_name"
											component="span"
											style={{
												color: "red",
											}}
										/>
									</div>
								</div>
								<div className="col-lg-12">
									<div className="form-group form-floating normal">
										<Field
											as="textarea"
											type="text"
											className="form-control"
											name="requirements"
											id="requirements"
											placeholder="Your message / Requirements*"
										/>
										<label
											htmlFor="requirements"
											className="form-label"
										>
											Your message / Requirements*
										</label>
										<ErrorMessage
											className="error-message"
											name="requirements"
											component="span"
											style={{
												color: "red",
											}}
										/>
									</div>
								</div>
								{isNew ? (
									<>
										<Col lg={7}>
											<div className="sign-nda">
												<a href="#" className="text-ex-small font-regular text-light-black">
													<Image
														src="/images/home/tick-circle.svg"
														alt=""
													/>{" "}
													100% confidential{" "}
												</a>
												<a href="#" className="text-ex-small font-regular text-light-black">
													<Image
														src="/images/home/tick-circle.svg"
														alt=""
													/>{" "}
													We sign NDA{" "}
												</a>
											</div>
											{captchaError && (
												<span style={{ color: "red" }}>
													{captchaError}
												</span>
											)}
										</Col>
										<Col lg={5}>
											<div className="budget-btn">
												<button
													type="submit"
													value="Submit"
													className="btn btn-primary btn-send"
												>
													Send Now
												</button>
											</div>
										</Col>
									</>
								) : (
									<div className="col-lg-12">
										<div className="hire-left-content-box">
											<ul>
												<li>
													<Image
														src="/images/tick-circle.svg"
														alt="tick-circle"
														loading="lazy"
														width="20"
														height="20"
													/>
													<p>100% confidential</p>
												</li>
												<li>
													<Image
														src="/images/tick-circle.svg"
														alt="tick-circle"
														loading="lazy"
														width="20"
														height="20"
													/>
													<p>We sign NDA</p>
												</li>
											</ul>
											<button
												type="submit"
												value="Submit"
												className="nav-link smoth-scroll btn btn-primary"
											>
												Send Now
											</button>
										</div>
										{captchaError && (
											<span style={{ color: "red" }}>
												{captchaError}
											</span>
										)}
									</div>
								)}
							</div>
						</div>
					</div>
					<ReCAPTCHA
						style={{ display: "inline" }}
						theme="dark"
						size="invisible"
						ref={reCaptchaRef}
						sitekey={sitekey}
					/>
				</Form>
			)}
		</Formik>
	);
};

export default BannerHireNowForm;
